  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

(function(){
  function initBell(){
          /* Runs synchronously during parse, immediately after the badge markup,
             so the unread class is applied before the browser's first paint.
             The badge starts hidden in CSS — this reveals it only when unread,
             which is why there is no flash for customers who already dismissed it. */
          (function () {
            var KEY = 'ws_bell_seen_v4';
            var TTL = 3 * 24 * 60 * 60 * 1000; /* Badge returns after 3 days */

            var badge = document.getElementById('notification-dot');
            var bell  = document.getElementById('notification-bell');
            if (!badge || !bell) return;

            var count = String(bell.getAttribute('data-notif-count') || '');

            function isUnread() {
              try {
                var raw = localStorage.getItem(KEY);
                if (!raw) return true;
                var seen = JSON.parse(raw);
                return !(String(seen.count) === count && (Date.now() - seen.ts) < TTL);
              } catch (e) {
                return true;
              }
            }

            function markRead() {
              try {
                localStorage.setItem(KEY, JSON.stringify({ count: count, ts: Date.now() }));
              } catch (e) {}
              badge.classList.remove('is-unread');
            }

            function apply() {
              if (isUnread()) {
                badge.classList.add('is-unread');
              } else {
                badge.classList.remove('is-unread');
              }
            }

            apply();

            /* pointerdown fires before navigation starts, so the write always lands */
            bell.addEventListener('pointerdown', markRead);
            bell.addEventListener('click', markRead);

            /* Back/forward cache can restore this page with a stale badge state */
            window.addEventListener('pageshow', function (e) {
              if (e.persisted) apply();
            });
          })();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initBell); } else { initBell(); }
})();
